
import { send as logSend } from 'smith-log';
import { getEasyApplySource } from '../utils/util'
    export default {
        name: 'PostForm',
        props: {
          mode: String,
          showForm: Number
        },
        data() {
            return {
              hasConfirmTerms: false,
              downloadUrl: '',
              qrcodePath: '',
                postFormData: {
                    firstName: '',
                    lastName: '',
                    mobile: '',
                    email: '',
                    fileId: '',
                    yourName: '',
                    // el-switch 绑定的模型，表示开关状态
                    allow: true
                },
                region: '+1',
                // userMobile: '',
                isSaveButtonDisabled: true,
                postFormRules: {
                    yourName: [
                        { required: true, message: 'Your Name is required.', trigger: 'blur' },
                    ],
                    firstName: [
                        { required: true, message: 'First Name is required.', trigger: 'blur' },
                    ],
                    lastName: [
                        { required: true, message: 'Last Name is required.', trigger: 'blur' },
                    ],
                    email: [
                        { type: 'email', required: true, message: 'Email Address is required', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: 'Phone Number is required', trigger: 'blur' },
                    ]
                },
                visible: false,
                isShowApplyBtn: false,
                title: 'Applied Successfully',
                content: 'Or contact the recruiter directly: ',
                content2: 'Scan QR code to chat with the Hiring Manager',
                content3: '+1(480) 930-4122'
            }
        },
        mounted() {
            console.log('name=====', this.$route.name)
            console.log('job_id===', this.$route.params.id)
        },
        methods: {
            fileLoadSucceed () {
                
            },
            fileLoadStart() {
                console.log('start')
            },
            async onClick () {

                if (this.showForm !== 1 && this.postFormData.yourName === '') {
                    return this.$message({
                        message: 'Your name is required',
                        type: 'error'
                    })
                }
                if (this.showForm === 1 && this.postFormData.firstName === '') {
                    return this.$message({
                        message: 'First name is required',
                        type: 'error'
                    })
                }
                if (this.showForm === 1 && this.postFormData.lastName === '') {
                    return this.$message({
                        message: 'Last name is required',
                        type: 'error'
                    })
                }
                if (this.postFormData.mobile === '') {
                    return this.$message({
                        message: 'Phone Number is required',
                        type: 'error'
                    })
                }
                if (this.postFormData.mobile.length < 10) {
                    return this.$message({
                        message: 'Please enter the true number',
                        type: 'error'
                    })
                }
                const valid = await this.$refs['applyForm'].validate().catch(e => e.email ? false : true)
                if (!valid) {
                  return this.$message({
                    message: 'Please enter a valid email',
                    type: 'error'
                  })
                }

                if (!this.hasConfirmTerms) {
                  this.$alert('Please check the user terms and conditions and privacy policy before continuing.', '', {
                    confirmButtonText: 'Ok',
                    customClass: 'confirm-terms-box'
                  })
                  return
                }
                let source = getEasyApplySource()
                const o = {
                    fileId: this.postFormData.fileId,
                    firstName: this.postFormData.firstName,
                    lastName: this.postFormData.lastName,
                    name: '',
                    email: this.postFormData.email,
                    mobile: this.region + this.postFormData.mobile,
                    jobId: this.$route.params.id,
                    source: source,
                    url: window.location.href,
                    allow: this.postFormData.allow
                }
                if (this.showForm === 1) {
                  o.firstName = this.postFormData.firstName
                  o.lastName = this.postFormData.lastName
                } else {
                  o.name = this.postFormData.yourName
                }
                console.log('oooooo---->', o)
                this.isShowApplyBtn = true
                const res = await this.$axios.post('https://usprod.workandroid.com/hy/candidate-service/rpc/insertCandidateFastResume', o)
                this.visible = true
                // console.log('res=====', res)
                console.log(gtag)
                gtag('event', 'job_apply_now_click' )

                const deviceId = localStorage.getItem('deviceId')
                this.$axios.get(`https://hirey.com/server/service/r-apply?deviceId=${deviceId}&uiType=${this.showForm}&source=${source}`)
                // logSend('MC', 'e_abtest_job_detail', {
                //   source,
                //   deviceId,
                //   ui: 1
                // })
                if (source === 'appcast') {
                  this.downloadUrl = 'https://hireyapp.onelink.me/UaHO/48lvamr3'
                  this.qrcodePath = require('~/assets/qrcode/appcast_qr_code.png')
                  if (res.data.code === 2000 && !res.data.data?.sourceDump) {
                    var script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = 'https://click.appcast.io/pixels/generic3-21506.js?ent=196';
                    document.body.appendChild(script); 
                  }
                } else if (this.$route.query.tlr_sid || source === 'talroo') {
                  this.downloadUrl = 'https://hirey.page.link/enT8'
                  this.qrcodePath = require('~/assets/qrcode/talroo_qr_code.png')
                  if (res.data.code === 2000 && !res.data.data?.sourceDump) {
                    var img = document.createElement('img');
                    img.type = 'text/javascript';
                    img.src = `https://www.jobs2careers.com/conversion2.php?tlr_sid=${this.$route.query.tlr_sid}`;
                    img.width = '0'
                    img.height = '0'
                    document.body.appendChild(img); 
                    // fetch(`https://www.jobs2careers.com/conversion2.php?tlr_sid=${this.$route.query.tlr_sid}`, { method: 'GET', mode: 'no-cors' })
                  }
                } else if (this.$route.query.tid || source === 'jobcase') {
                  this.downloadUrl = 'https://hirey.page.link/rY6Y'
                  this.qrcodePath = require('~/assets/qrcode/jobcase_qr_code.png')
                  if (res.data.code === 2000 && !res.data.data?.sourceDump) {
                    var img = document.createElement('img');
                    img.type = 'text/javascript';
                    img.src = 'https://pcvn.jobcase.com/convert.jc?org=NzUxMDM%3D';
                    img.width = '0'
                    img.height = '0'
                    document.body.appendChild(img); 
                  }
                } else if (this.$route.query.xlscid || source === 'expertJobMatch') {
                  this.downloadUrl = 'https://hirey.page.link/k29C'
                  this.qrcodePath = require('~/assets/qrcode/expertJobMatch_qr_code.png')
                  if (res.data.code === 2000 && !res.data.data?.sourceDump) {
                    var img = document.createElement('img');
                    img.type = 'text/javascript';
                    img.src = `https://xtrk.sjobs.co/pb?xlscid=${this.$route.query.xlscid}`;
                    img.width = '0'
                    img.height = '0'
                    document.body.appendChild(img); 
                  }
                } else if (this.$route.query.click_id || source === 'jobget') {
                  this.downloadUrl = 'https://hirey.page.link/nPwh'
                  this.qrcodePath = require('~/assets/qrcode/jobget_qr_code.png')
                  if (res.data.code === 2000 && !res.data.data?.sourceDump) {
                    var img = document.createElement('img');
                    img.type = 'text/javascript';
                    img.src = `https://jobs.jobget.com/s2s?click_id=${this.$route.query.click_id}`;
                    img.width = '0'
                    img.height = '0'
                    document.body.appendChild(img); 
                  }
                }
            },
            async sendAuthenticationData(id) {
                if (this.uploading) {
                  return
                }
                this.uploading = true
                try {
                  const data = {
                    fileId: id,
                    recruiterType: 1,
                    docType: 5,
                    description: 'Any other Authorised Document',
                  }
                  if(this.$route?.params?.resubmit && this.$route?.params?.resubmitType!==undefined) {
                    data.resubmitType = this.$route.params.resubmitType
                    if(Number(this.$route.params.resubmitType) === 2) {
                      data.companyId = this.companyId
                      data.companyFileId = this.$route.params.companyFileId
                    }
                  }
                  const res = await this.$api.verify.sendPersonalDoc(data)
                  if(!res.code) {
                    await this.$store.dispatch('user/updateUserInfo')
                    redirectByRoleInfo(this.$store.state?.user?.userInfo?.roleInfo, this.$router)
                  }
                } catch (e) {
                  console.error(e)
                }
                this.fileLoadSucceed()
                this.uploading = false
              },
              getFileId (id) {
                this.postFormData.fileId = id
              },
        }
    }
